import { render } from "./Depositable.vue?vue&type=template&id=34168362"
import script from "./Depositable.vue?vue&type=script&lang=js"
export * from "./Depositable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__